const sessions = {
  sessionBlocked:
    "You have been logged out because your account was accessed from another device.",
  sessionWarning: "If this wasn't you, please change your password.",
  sessionTabDisabled: "This tab is disabled.",
  sessionTabOpened: "Your account is already open in another tab.",
  sessionCloseTab: "You can close this tab.",
  sessionUniqueWarning: "iizenglish can only be active in one tab at a time.",
};

export default sessions;
